const reasons = [
  {
    symbol: "✦",
    title: "Personalized Itineraries",
    description:
      "Every plan is built around your family — your pace, your priorities, your budget. No templates. No one-size-fits-all Disney trips.",
  },
  {
    symbol: "◈",
    title: "Expert Knowledge",
    description:
      "Disney planning is genuinely complex. I stay current on park updates, dining windows, Lightning Lane™ timing, and resort changes so you don't have to.",
  },
  {
    symbol: "◇",
    title: "Zero Cost to You",
    description:
      "Travel advisors are compensated by travel suppliers, not clients. Full-service planning at no additional charge — always.",
  },
];

export const HowIHelpSection = () => {
  return (
    <section className="py-28 bg-background" id="how-it-works" aria-label="Why book with us">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-4 mb-5">
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-gold/40" />
              <p className="font-cinzel text-[0.6rem] text-gold tracking-[0.35em] uppercase">The Difference</p>
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-gold/40" />
            </div>
            <h2 className="font-serif font-light text-foreground"
                style={{ fontSize: "clamp(1.9rem, 4vw, 2.8rem)" }}>
              Why Book With Me?
            </h2>
          </div>

          {/* 3-col cards */}
          <div className="grid md:grid-cols-3 gap-6">
            {reasons.map((reason, index) => (
              <div
                key={index}
                className="bg-card border border-border rounded-[3px] p-8 text-center card-glow animate-slide-up relative overflow-hidden"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Soft radial glow behind symbol */}
                <div className="absolute top-6 left-1/2 -translate-x-1/2 w-20 h-20 rounded-full bg-gold/5 blur-xl pointer-events-none" />

                <div
                  className="text-2xl text-gold mb-6 select-none relative z-10"
                  aria-hidden="true"
                  style={{ fontFamily: "serif" }}
                >
                  {reason.symbol}
                </div>
                <h3 className="font-serif text-xl font-light text-foreground mb-4 relative z-10">
                  {reason.title}
                </h3>
                <p className="text-muted-foreground text-[0.875rem] leading-relaxed font-sans relative z-10">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
